import React from 'react';
import renderHTML from 'react-render-html';
import BsipCallingPlanItem from '../bsip-calling-plan-item/bsip-callling-plan-item';
import { stripStartingAndEndingPTags } from '../../../ssm-homepage/ssm-homepage.actions';

import {
  BSIP_CALLING_PLAN_SMALL,
  BSIP_CALLING_PLAN_MEDIUM,
  BSIP_CALLING_PLAN_LARGE,
} from '../../../../app-constants';
import './bsip-calling-plan.css';

const BsipCallingPlan = (props) => {
  const {
    authorableContent: {
      title,
      bsipTableHeading,
      callInclusionsText,
      smallPlan,
      mediumPlan,
      largePlan,
      gstText,
      preSummary,
      postSummary,
    },
    siteId,
    sitesBsipCallingPlanSelection,
    callingPlanCheckBoxChanged,
    numberOfTrunks,
  } = props;

  const bodyText = `${preSummary} ${numberOfTrunks} `;

  const smallPlanContent = { ...smallPlan, callInclusionsText, gstText };
  const mediumPlanContent = { ...mediumPlan, callInclusionsText, gstText };
  const largePlanContent = { ...largePlan, callInclusionsText, gstText };

  return (
    <div className="bsip-calling-plan">
      <div className="row">
        <div className="col-12 pl-sm-0">
          <h2 id="bsip-calling-plan-heading" className="bsip-calling-plan-heading">{title}</h2>
        </div>
      </div>
      <div className="row">
        <div className="col-12 pl-sm-0">
          <p className="calling-plan-description">{bodyText}{renderHTML(stripStartingAndEndingPTags(postSummary))}</p>
        </div>
      </div>
      <div className="row table-border">
        <div className="col-md-3 col-sm-12 table-heading">
          {bsipTableHeading}
        </div>
        <div className="col-md-3 col-sm-12 padding-text">
          <BsipCallingPlanItem
            id={`${siteId}-smallPlan`}
            authorableContent={smallPlanContent}
            callingPlanCheckBoxChanged={callingPlanCheckBoxChanged}
            planSelected={sitesBsipCallingPlanSelection && sitesBsipCallingPlanSelection[`${siteId}`] === BSIP_CALLING_PLAN_SMALL}
          />
        </div>
        <div className="col-md-3 col-sm-12 padding-text">
          <BsipCallingPlanItem
            id={`${siteId}-mediumPlan`}
            authorableContent={mediumPlanContent}
            callingPlanCheckBoxChanged={callingPlanCheckBoxChanged}
            planSelected={sitesBsipCallingPlanSelection && sitesBsipCallingPlanSelection[`${siteId}`] === BSIP_CALLING_PLAN_MEDIUM}
          />
        </div>
        <div className="col-md-3 col-sm-12 padding-text">
          <BsipCallingPlanItem
            id={`${siteId}-largePlan`}
            authorableContent={largePlanContent}
            callingPlanCheckBoxChanged={callingPlanCheckBoxChanged}
            planSelected={sitesBsipCallingPlanSelection && sitesBsipCallingPlanSelection[`${siteId}`] === BSIP_CALLING_PLAN_LARGE}
          />
        </div>
      </div>
    </div>
  );
};

export default BsipCallingPlan;
